<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          Manage Quota Rate
        </div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" class="pt-5">
                  <v-text-field
                    label="Search"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchDataRateList(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </div>

          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-data-table
                :headers="headers"
                :items="ListData"
                hide-default-footer
                style="color: #332f2fde"
                :items-per-page="itemsPerPage"
                :mobile-breakpoint="0"
                :page.sync="page"
                single-line
                hide-details
              >
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <td class="header-table-css">{{ item.rateCode }}</td>
                    <td class="header-table-css">{{ item.vehicleName }}</td>
                    <td class="header-table-css">{{ item.tenantName }}</td>
                    <td class="header-table-css">{{ item.rateDetail }}</td>
                    <td class="header-table-css">{{ item.quotaRemaining }}</td>
                    <td style="text-align: center">
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        small
                        color="orange"
                        @click="OpenRateDetailDialog(item)"
                      >
                        <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                    label="10/page"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="RateDetailDialog" persistent max-width="800">
      <v-card class="pa-4 rounded-xl">
        <v-card-title class="d-flex align-center">
          <span class="text-h6 font-weight-bold">Manage Quota Rate</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            variant="text"
            color="grey darken-1"
            @click="CloseRateDetailDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="4" v-if="EditStatus">
              <v-text-field
                label="RateCode"
                v-model="RateCode"
                outlined
                dense
                disabled
              />
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                label="TenantName"
                v-model="TenantName"
                outlined
                dense
                disabled
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                label="VehicleType"
                :value="vehicleTypeText"
                outlined
                dense
                disabled
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                label="Rate Detail"
                v-model="RateDetail"
                outlined
                dense
                disabled
              />
            </v-col>
          </v-row>
          <v-row dense class="d-flex justify-end">
            <v-col cols="12" md="3">
              <v-text-field
                label="Quota"
                v-model="Quota"
                outlined
                type="number"
                dense
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end pt-4">
          <v-btn
            v-if="EditStatus"
            color="success"
            class="mr-2 elevation-1 rounded-lg white--text text-capitalize"
            width="120"
            @click="UpdateQuotaRate()"
          >
            Update
          </v-btn>
          <v-btn
            class="elevation-1 rounded-lg text-capitalize"
            color="grey lighten-2"
            width="120"
            @click="CloseRateDetailDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ManageQuotaRate",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,
      ListData: [],
      RateDetailDialog: false,
      EditStatus: false,

      RateCode: null,
      TenantName: "",
      RateDetail: "",
      Quota: null,
      vehicleType: null,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        {
          text: "RateCode",
          align: "left",
          sortable: false,
        },
        {
          text: "VehicleType",
          align: "left",
          sortable: false,
        },
        {
          text: "TenantName",
          align: "left",
          sortable: false,
        },
        {
          text: "RateDetail",
          align: "left",
          sortable: false,
        },
        {
          text: "QuotaRemaining",
          align: "left",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },

    vehicleTypeText() {
      return this.vehicleType === 0 ? "Car" : "Motorcycle";
    }
  },

  async mounted() {
    let self = this;
    await self.getDataRateCodeList();
  },

  methods: {
    getDataRateCodeList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perpage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Redemption/getDataRateCodeList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}Redemption/getDataRateCodeList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perpage: value,
      };
      axios
        .post(`${self.url}Redemption/getDataRateCodeList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    SearchDataRateList(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perpage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Redemption/getDataRateCodeList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    BindingData(data) {
      let self = this;
      self.EditStatus = true;
      self.RateCode = data.rateCode;
      self.TenantName = data.tenantName;
      self.RateDetail = data.templateName;
      self.Quota = data.limitQuota;
      self.vehicleType = data.vehicleType;
      self.RateDetailDialog = true;
    },

    CloseRateDetailDialog() {
      let self = this;
      self.EditStatus = false;
      self.RateCode = null;
      self.TenantName = "";
      self.RateDetail = "";
      self.Quota = null;
      self.RateDetailDialog = false;
    },

    OpenRateDetailDialog(data) {
      let self = this;
      if (data.templateID != 0) {
        self.LoadingDialog = true;
        let temp = {
          rateCode: data.rateCode,
          vehicleType: data.vehicleType,
        };
        axios
          .post(`${self.url}Redemption/getDataRateCodeByID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.BindingData(response.data.data);
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    UpdateQuotaRate() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        rateCode: self.RateCode,
        vehicleType: self.vehicleType,
        quota: self.Quota
      };
      axios
        .post(`${self.url}Redemption/UpdateQuotaRate`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.CloseRateDetailDialog();
            self.getDataRateCodeList();
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },
  },
};
</script>
  <style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}
</style>
  